export const CavityDecaySvg = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5306 4.75838C17.6973 3.96735 16.8639 3.96735 15.1973 3.17632L12.2599 2.46077C10.9283 1.43467 9.28343 0.803223 7.63852 0.803223C3.48708 0.803223 0.197266 4.19725 0.197266 8.38059V8.85418C0.197266 10.1171 0.432253 11.301 0.980555 12.485C2.69727 15.0418 6.86393 23.7432 16.2649 19.788C17.6973 17.4149 20.1973 12.3495 20.1973 11.0866V8.38059C19.3639 6.34045 20.1973 7.13148 18.5306 4.75838Z"
        fill="#F87171"
      />
    </svg>
  );
};
